<template>
  <div class="screen-container" :class="{ allScreen: isAllScreen }">
    <div class="search">
      <el-form inline>
        <el-form-item :label="$t('ocean-bi::sale-area::分析维度')">
          <el-select v-model="dimensionType" style="width: 110px; margin-right: 8px" @change="changeDimension">
            <el-option :label="$t('ocean-bi::sale-area::商品品类')" value="category"></el-option>
            <el-option :label="$t('ocean-bi::sale-area::商品SPU')" value="spu"></el-option>
          </el-select>
          <el-select
            multiple
            v-model="params.category"
            v-show="dimensionType === 'category'"
            collapse-tags
            :placeholder="$t('ocean-bi::sale-area::请选择商品品类')"
          >
            <el-option
              v-for="item in dimensionOptions.categoryList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select
            multiple
            filterable
            remote
            v-model="params.spuId"
            :remote-method="getSpuList"
            v-show="dimensionType === 'spu'"
            :placeholder="$t('ocean-bi::sale-area::请搜索商品SPU')"
          >
            <el-option
              v-for="item in dimensionOptions.spuIdList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('ocean-bi::sale-area::价格带')">
          <div>
            <el-input
              v-model="params.minPrice"
              style="width: 90px"
              :placeholder="$t('ocean-bi::sale-area::最低价格')"
            ></el-input>
            <span>-</span>
            <el-input
              v-model="params.maxPrice"
              style="width: 90px"
              :placeholder="$t('ocean-bi::sale-area::最高价格')"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item :label="$t('ocean-bi::sale-area::排序')">
          <el-select v-model="params.sortWord" style="width: 150px">
            <el-option v-for="item in sortOption" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('ocean-bi::sale-area::统计时间')">
          <el-date-picker
            style="width: 260px"
            :appendToBody="true"
            :clearable="false"
            v-model="date"
            @change="handlerDateChange"
            type="daterange"
            unlink-panels
            :range-separator="$t('system::time::text::include')"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getAllData">{{ $t('system::common::btn::search') }}</el-button>
          <el-button type="info" style="background-color: #666666; border-color: #666666" @click="reset">
            {{ $t('system::common::btn::reset') }}
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div style="display: flex">
      <div class="sale-range-city">
        <div class="title">
          {{ $t(`ocean-bi::sale-area::${translateKey[sortWord]}`) + $t('ocean-bi::sale-area::前十城市概况') }}-{{
            params.countryName || $t('ocean-bi::sale-area::全球')
          }}
        </div>
        <div class="cityRange" v-loading="loading.range" element-loading-background="rgba(34, 34, 36, 0.3)">
          <template v-if="cityRangeList.length">
            <div class="bar-item" v-for="item in cityRangeList" :key="item.city">
              <el-tooltip class="item" effect="dark" :content="item.city" placement="top-start">
                <div class="bar-name">{{ item.city }}</div>
              </el-tooltip>

              <el-popover
                placement="right-start"
                width="200"
                trigger="hover"
                class="progress"
                :append-to-body="false"
                popper-class="bar-popover"
              >
                <div class="bar-popover-title">{{ item.city }}</div>
                <div class="bar-popover-content">
                  <span>{{ $t('ocean-bi::sale-area::销量') }}</span>
                  <span>{{ item.sale }}</span>
                </div>
                <div class="bar-popover-content">
                  <span>{{ $t('ocean-bi::sale-area::成交额') }}</span>
                  <span>${{ Number(item.grandTotalUsd).toFixed(2) }}</span>
                </div>
                <div class="bar-popover-content">
                  <span>{{ $t('ocean-bi::sale-area::退款量') }}</span>
                  <span>{{ item.refundSale }}</span>
                </div>
                <div class="bar-popover-content">
                  <span>{{ $t('ocean-bi::sale-area::退款金额') }}</span>
                  <span>${{ Number(item.refundUsd).toFixed(2) }}</span>
                </div>
                <el-progress
                  :text-inside="true"
                  :stroke-width="18"
                  :percentage="item.per"
                  :format="
                    val => {
                      return translateKey[sortWord].includes('Usd')
                        ? Number(item[translateKey[sortWord]]).toFixed(2)
                        : item[translateKey[sortWord]]
                    }
                  "
                  slot="reference"
                ></el-progress>
              </el-popover>
            </div>
          </template>
          <ZDefaultData
            :custom="{ height: '360px', img: require('@/assets/images/emptyDefault/empty_dark.png') }"
            style="background: none"
            v-else
          ></ZDefaultData>
        </div>
      </div>
      <Map
        v-loading="loading.map"
        ref="mapContainer"
        class="map"
        :config="mapConfig"
        element-loading-background="rgba(45, 45, 48, 0.3)"
        @changeZone="changeZone"
      ></Map>
    </div>
    <div class="category-sale">
      <el-row :gutter="16">
        <el-col :span="12">
          <div style="margin-bottom: 16px; font-weight: bold">
            {{ $t('ocean-bi::sale-area::品类销售概况') }}-{{ params.countryName || $t('ocean-bi::sale-area::全球') }}
          </div>
          <span style="color: #ffd74f; cursor: pointer">
            <span @click="toReCategory(0)">{{ $t('system::common::select_all') }}</span>
            <span @click="toReCategory(1)" v-show="categoryLevel.level1.name">/{{ categoryLevel.level1.name }}</span>
            <span @click="toReCategory(2)" v-show="categoryLevel.level2.name">/{{ categoryLevel.level2.name }}</span>
          </span>
          <div
            class="category-overview"
            v-loading="loading.saleWorld"
            element-loading-background="rgba(34, 34, 36, 0.3)"
          >
            <template v-if="saleCategoryForWorld.length">
              <div class="bar-item" v-for="item in saleCategoryForWorld" :key="item.city" @click="toNextCategory(item)">
                <el-tooltip class="item" effect="dark" :content="item.goodsOneType" placement="top-start">
                  <div class="bar-name">{{ item[`${categoryName}Type`] }}</div>
                </el-tooltip>

                <el-popover
                  placement="right-start"
                  width="200"
                  trigger="hover"
                  class="progress"
                  :append-to-body="false"
                  popper-class="bar-popover"
                >
                  <div class="bar-popover-title">{{ item[`${categoryName}Type`] }}</div>
                  <div class="bar-popover-content">
                    <span>{{ $t('ocean-bi::sale-area::销量') }}</span>
                    <span>{{ item.sale }}</span>
                  </div>
                  <div class="bar-popover-content">
                    <span>{{ $t('ocean-bi::sale-area::成交额') }}</span>
                    <span>${{ Number(item.grandTotalUsd).toFixed(2) }}</span>
                  </div>
                  <div class="bar-popover-content">
                    <span>{{ $t('ocean-bi::sale-area::退款量') }}</span>
                    <span>{{ item.refundSale }}</span>
                  </div>
                  <div class="bar-popover-content">
                    <span>{{ $t('ocean-bi::sale-area::退款金额') }}</span>
                    <span>${{ Number(item.refundUsd).toFixed(2) }}</span>
                  </div>
                  <el-progress
                    :text-inside="true"
                    :stroke-width="18"
                    :percentage="item.per"
                    color="#68D287"
                    :format="val => item.sale"
                    slot="reference"
                    style="cursor: pointer"
                  ></el-progress>
                </el-popover>
              </div>
            </template>
            <ZDefaultData
              v-else
              :custom="{ height: '200px', img: require('@/assets/images/emptyDefault/empty_dark.png') }"
              style="background: none"
            ></ZDefaultData>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="custom-card">
            <div class="header">
              <span>{{ $t('ocean-bi::sale-area::品类销售趋势') }}</span>
              <span style="opacity: 0.6">
                {{ categoryLevel.level2.name || categoryLevel.level1.name || $t('ocean-bi::sale-area::全品类') }}
              </span>
            </div>
            <div v-loading="loading.saleTrend" element-loading-background="rgba(40, 40, 42, 0.3)">
              <div class="category-trend" ref="categoryTrend" v-show="saleTrend.length"></div>
              <ZDefaultData
                :custom="{ height: '230px', img: require('@/assets/images/emptyDefault/empty_dark.png') }"
                style="background: none"
                v-show="!saleTrend.length"
              ></ZDefaultData>
            </div>
          </div>
        </el-col>
        <el-col :span="24">
          <div class="custom-card" style="height: 450px; margin-top: 24px">
            <div class="header">
              <span>{{ $t('ocean-bi::sale-area::SPU销售概况') }}</span>
              <span style="opacity: 0.6">
                {{ categoryLevel.level2.name || categoryLevel.level1.name || $t('ocean-bi::sale-area::全品类') }}
              </span>
            </div>
            <div class="spu-table" v-loading="loading.spuTrend" element-loading-background="rgba(40, 40, 42, 0.3)">
              <el-table
                :data="saleCategoryForSpu"
                @handleScrollEnd="onTableEnd"
                height="400"
                style="border-radius: 0px 0px 6px 6px"
                :highlight-current-row="false"
              >
                <el-table-column prop="spuId" label="SPU_ID" width="160"></el-table-column>
                <el-table-column prop="image" :label="$t('ocean-bi::sale-area::图片')" width="100">
                  <template slot-scope="{ row }">
                    <ZImg :src="row.spuIcon" style="width: 40px; height: 40px; border-radius: 4px" />
                  </template>
                </el-table-column>
                <el-table-column prop="price" :label="$t('ocean-bi::sale-area::售价')" min-width="100">
                  <template slot-scope="{ row }">
                    ${{ (Number(row.minPrice) || 0).toFixed(2) }}~${{ (Number(row.maxPrice) || 0).toFixed(2) }}
                  </template>
                </el-table-column>
                <el-table-column prop="sale" :label="$t('ocean-bi::sale-area::销量')" min-width="160"></el-table-column>
                <el-table-column prop="saleRate" :label="$t('ocean-bi::sale-area::销量占比')" min-width="120">
                  <template slot-scope="{ row }">
                    <span>{{ row.saleRate }}%</span>
                  </template>
                </el-table-column>
                <el-table-column prop="grandTotalUsd" :label="$t('ocean-bi::sale-area::销售额')" min-width="160">
                  <template slot-scope="{ row }">
                    <span>{{ Number(row.grandTotalUsd).toFixed(2) }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="refundSale"
                  :label="$t('ocean-bi::sale-area::退款量')"
                  width="120"
                ></el-table-column>
              </el-table>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <handleIcon @allScreen="toggleAllScreenFull(!isAllScreen)" :isAllScreen="isAllScreen">
      <template slot="menu">
        <li @click="getAllData">
          <div class="icon">
            <i class="iconfont iconRefresh"></i>
          </div>
          <span>{{ $t('dashboard-bi::default-board::refresh') }}</span>
        </li>
      </template>
    </handleIcon>
  </div>
</template>

<script>
import moment from 'moment'
import echarts from '../../../public/js/echart/echarts.min.js'
import { pickerOptions } from '@/utils/datepickerConfig'
import handleIcon from '@/components/handle-icon/index.vue'
import Map from '@/components/data-analysis/map/index.vue'
import { toggleAllScreen } from '@/utils/utils.js'
import { addResizeListener, removeResizeListener } from '@/utils/resize-event'
import {
  getCategoryList,
  getSpuList,
  getAreaRefund,
  getCityRange,
  getSaleCategoryForWorld,
  getSaleCategoryTrend,
  getSaleCategoryForSpu,
} from '@/server/etl'
import ZDefaultData from '@/components/common/default-data/main'
export default {
  name: 'big-screen',
  components: { handleIcon, Map, ZDefaultData },
  data() {
    return {
      listenAllScreenKeyUp: null,
      countryFocusInterval: null,
      dimensionType: 'category',
      date: [moment().subtract(3, 'months'), moment()],
      params: {
        orgUnitId: this.$store.state.user.merchantId,
        // orgUnitId: 100,
        sortWord: 'sale',
        startDate: moment().subtract(3, 'months').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        spuId: [],
        category: [],
        countryCode: '',
        countryName: '',
        minPrice: '',
        maxPrice: '',
      },
      sortWord: 'sale',
      dimensionOptions: {
        categoryList: [],
        spuIdList: [],
      },
      sortOption: [
        { label: this.$t('ocean-bi::sale-area::按成交额排序'), value: 'grand_total_usd' },
        { label: this.$t('ocean-bi::sale-area::按销量排序'), value: 'sale' },
        { label: this.$t('ocean-bi::sale-area::按退款量排序'), value: 'refund_sale' },
        { label: this.$t('ocean-bi::sale-area::按退款金额排序'), value: 'refund_usd' },
      ],
      translateKey: {
        grand_total_usd: 'grandTotalUsd',
        sale: 'sale',
        refund_sale: 'refundSale',
        refund_usd: 'refundUsd',
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
        ...pickerOptions,
      },
      mapConfig: {
        formatter: [
          { name: this.$t('ocean-bi::sale-area::销量'), key: 'sale', unit: '' },
          { name: this.$t('ocean-bi::sale-area::成交额'), key: 'grandTotalUsd', unit: '$' },
          { name: this.$t('ocean-bi::sale-area::退款量'), key: 'refundSale', unit: '' },
          { name: this.$t('ocean-bi::sale-area::退款金额'), key: 'refundUsd', unit: '$' },
        ],
      },
      loading: {
        map: false,
        range: false,
        saleWorld: false,
        saleTrend: false,
        spuTrend: false,
      },
      // 品类可下钻两级
      categoryLevel: { level1: { name: '', id: '' }, level2: { name: '', id: '' } },
      cityRangeList: [],
      saleCategoryForWorld: [],
      saleTrend: [],
      saleCategoryForSpu: [],
      scatterData: [],
      trendChart: null,
      tablePage: {
        pageNum: 1,
        pageSize: 20,
        end: false,
      },
    }
  },
  computed: {
    isAllScreen() {
      return this.$store.state.isAllScreen
    },
    categoryName() {
      if (this.categoryLevel.level2.name) {
        return 'goodsThree'
      } else if (this.categoryLevel.level1.name) {
        return 'goodsTwo'
      } else {
        return 'goodsOne'
      }
    },
  },
  mounted() {
    this.getCategoryList()
    this.getAllData()

    window.addEventListener('resize', () => {
      if (this.trendChart) {
        setTimeout(() => {
          this.trendChart.resize()
        }, 60)
      }
    })
  },
  methods: {
    handlerDateChange(date) {
      this.params.startDate = moment(date[0]).format('YYYY-MM-DD')
      this.params.endDate = moment(date[1]).format('YYYY-MM-DD')
      // this.getAllData()
    },
    toNextCategory(item) {
      switch (this.categoryName) {
        case 'goodsThree':
          break
        case 'goodsTwo':
          this.categoryLevel = { ...this.categoryLevel, level2: { name: item.goodsTwoType, id: item.goodsTwoId } }
          break
        case 'goodsOne':
          this.categoryLevel = { ...this.categoryLevel, level1: { name: item.goodsOneType, id: item.goodsOneId } }
          break
      }
      this.refreshCategory()
    },
    toReCategory(type) {
      if (
        (type === 1 && !this.categoryLevel.level2.name) ||
        (type === 0 && !this.categoryLevel.level1.name) ||
        type === 2
      ) {
        return
      }
      switch (type) {
        case 2:
          // this.categoryLevel = { ...this.categoryLevel, level2: { name: '', id: '' } }
          break
        case 1:
          this.categoryLevel = { ...this.categoryLevel, level2: { name: '', id: '' } }
          break
        case 0:
          this.categoryLevel = { level1: { name: '', id: '' }, level2: { name: '', id: '' } }
          break
      }
      this.refreshCategory()
    },
    refreshCategory() {
      this.tablePage.pageNum = 1
      this.tablePage.end = false
      this.saleCategoryForSpu = []
      this.getSaleCategoryForWorld()
      this.getSaleCategoryTrend()
      this.getSaleCategoryForSpu('change')
    },
    onTableEnd() {
      if (!this.tablePage.end && !this.loading.spuTrend) {
        this.tablePage.pageNum++
        this.getSaleCategoryForSpu()
      }
    },
    changeDimension(val) {
      if (val === 'category') {
        this.params.spuId = []
      } else if (val === 'spu') {
        this.params.category = []
      }
      // this.getAllData()
    },
    async getSearchList() {
      if (this.dimensionType === 'category') {
        this.getCategoryList()
      } else if (this.dimensionType === 'spu') {
        this.getSpuList()
      }
    },
    async getCategoryList() {
      const { data } = await getCategoryList({ orgUnitId: this.params.orgUnitId })
      if (data.code === this.$code) {
        if (data.data.datas) {
          console.log(data.data.datas)
          this.dimensionOptions.categoryList = data.data.datas.map(el => {
            return { label: el.categoryName, value: el.categoryId }
          })
        }
      }
    },
    async getSpuList(query) {
      if (!query) {
        return
      }
      const { data } = await getSpuList({ spuId: query, pageSize: 10, pageNum: 1, orgUnitId: this.params.orgUnitId })
      if (data.code === this.$code) {
        if (data.data.datas) {
          this.dimensionOptions.spuIdList = data.data.datas.map(el => {
            return { label: el.spuId, value: el.spuId }
          })
        }
      }
    },
    getAllData() {
      this.tablePage.pageNum = 1
      this.tablePage.end = false
      this.saleCategoryForSpu = []
      this.sortWord = this.params.sortWord
      this.getCityRange()
      this.getSaleCategoryForWorld()
      this.getSaleCategoryTrend()
      this.getSaleCategoryForSpu('change')
      this.getAreaRefund()
    },
    toggleAllScreenFull(bool) {
      this.$store.commit('setScreen', bool)
      toggleAllScreen()
    },
    async getAreaRefund() {
      this.loading.map = true
      const { data } = await getAreaRefund({
        ...this.params,
      })
      this.loading.map = false
      if (data.code === this.$code) {
        this.scatterData = data.data.datas.map(scatter => ({
          name: this.params.countryName ? scatter.province : scatter.countryNameEn,
          value: scatter.refundUsd,
          data: { ...scatter },
        }))
      }
      console.log(this.$refs.mapContainer, ' this.$refs.mapContainer')
      this.$refs.mapContainer.myChart.setOption({
        // 设置echarts数据
        series: [
          {
            data: this.scatterData,
          },
        ],
      })
      let showData = this.scatterData
        .sort((a, b) => {
          return a.value > b.value
        })
        .map(item => item.name)
        .slice(0, 10)
      if (!showData.length) return
      let showIndex = 0

      if (this.countryFocusInterval) {
        // 隐藏之前显示的
        this.$refs.mapContainer.myChart.dispatchAction({
          type: 'downplay',
          seriesIndex: 0,
        })
        this.$refs.mapContainer.myChart.dispatchAction({
          type: 'hideTip',
          seriesIndex: 0,
        })
        clearInterval(this.countryFocusInterval)
      }
      setTimeout(() => {
        // 前十国家循环显示tooltips
        this.$refs.mapContainer.myChart.dispatchAction({
          type: 'highlight',
          seriesIndex: 0,
          name: showData[showIndex],
        })
        this.$refs.mapContainer.myChart.dispatchAction({
          type: 'showTip',
          seriesIndex: 0,
          name: showData[showIndex],
        })
        this.countryFocusInterval = setInterval(() => {
          if (showIndex < showData.length - 1) {
            showIndex++
          } else {
            showIndex = 0
          }
          // 隐藏之前显示的
          this.$refs.mapContainer.myChart.dispatchAction({
            type: 'downplay',
            seriesIndex: 0,
          })
          this.$refs.mapContainer.myChart.dispatchAction({
            type: 'hideTip',
            seriesIndex: 0,
          })
          // 显示tooltips
          this.$refs.mapContainer.myChart.dispatchAction({
            type: 'highlight',
            seriesIndex: 0,
            name: showData[showIndex],
          })
          this.$refs.mapContainer.myChart.dispatchAction({
            type: 'showTip',
            seriesIndex: 0,
            name: showData[showIndex],
          })
        }, 8000)
      }, 400)
    },
    async getCityRange() {
      this.loading.range = true
      const { data } = await getCityRange({
        ...this.params,
      })
      this.loading.range = false
      if (data.code === this.$code) {
        if (data.data.datas) {
          let max = data.data.datas.length ? Number(data.data.datas[0][this.translateKey[this.params.sortWord]]) : 1
          if (!max) {
            max = 1
          }
          this.cityRangeList = data.data.datas.map(el => {
            return { ...el, per: (Number(el[this.translateKey[this.params.sortWord]]) / max) * 100 }
            // return { ...el, per: (0 / 1) * 100 }
          })
        }
      }
    },
    async getSaleCategoryForWorld() {
      this.loading.saleWorld = true
      let params = { ...this.params }
      if (this.categoryLevel.level1.id) {
        params = { ...params, categoryLevel1: this.categoryLevel.level1.id }
      }
      if (this.categoryLevel.level2.id) {
        params = { ...params, categoryLevel2: this.categoryLevel.level2.id }
      }
      const { data } = await getSaleCategoryForWorld({
        ...params,
      })

      this.loading.saleWorld = false
      if (data.code === this.$code) {
        if (data.data.datas) {
          let sort = [...data.data.datas]
          sort.sort((a, b) => {
            return Number(b.sale) - Number(a.sale)
          })
          let max = sort.length ? Number(sort[0].sale) : 1
          this.saleCategoryForWorld = data.data.datas.map(el => {
            return { ...el, per: (Number(el.sale) / max) * 100 }
          })
        }
      }
    },
    async getSaleCategoryTrend() {
      this.loading.saleTrend = true
      let params = { ...this.params }
      if (this.categoryLevel.level1.id) {
        params = { ...params, categoryLevel1: this.categoryLevel.level1.id }
      } else if (this.categoryLevel.level2.id) {
        params = { ...params, categoryLevel2: this.categoryLevel.level2.id }
      }
      this.saleTrend = []
      const { data } = await getSaleCategoryTrend({
        ...params,
        type: moment(params.endDate).diff(moment(params.startDate), 'day') > 31 ? 1 : 0,
      })
      this.loading.saleTrend = false
      if (data.code === this.$code) {
        if (data.data.datas) {
          this.saleTrend = data.data.datas
          this.$nextTick(() => {
            this.setCategoryTrendChart(data.data.datas)
          })
        }
      }
    },
    changePrice() {
      // this.tablePage.pageNum = 1
      // this.tablePage.end = false
      // this.saleCategoryForSpu = []
      // this.getSaleCategoryForSpu('change')
      this.getAllData()
    },
    reset() {
      this.date = [moment().subtract(3, 'months'), moment()]
      this.params = {
        orgUnitId: this.$store.state.user.merchantId,
        sortWord: 'sale',
        startDate: moment().subtract(3, 'months').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        spuId: [],
        category: [],
        countryCode: '',
        countryName: '',
        minPrice: '',
        maxPrice: '',
      }
      this.getAllData()
    },
    async getSaleCategoryForSpu(type) {
      this.loading.spuTrend = true
      let params = { ...this.params }
      if (this.categoryLevel.level1.id) {
        params = { ...params, categoryLevel1: this.categoryLevel.level1.id }
      } else if (this.categoryLevel.level2.id) {
        params = { ...params, categoryLevel2: this.categoryLevel.level2.id }
      }
      if (!params.minPrice) {
        delete params.minPrice
      }
      if (!params.maxPrice) {
        delete params.maxPrice
      }
      let { pageSize, pageNum } = this.tablePage
      const { data } = await getSaleCategoryForSpu({
        ...params,
        pageSize: pageSize,
        pageNum: pageNum,
      })
      this.loading.spuTrend = false
      if (data.code === this.$code) {
        if (data.data.datas) {
          // 刷新则重制分页
          if (type) {
            this.tablePage.pageNum = 1
            this.tablePage.end = false
            this.saleCategoryForSpu = []
          }
          this.saleCategoryForSpu = [...this.saleCategoryForSpu, ...data.data.datas]
          if (this.saleCategoryForSpu.length >= data.data.totalSize) {
            this.tablePage.end = true
          }
        }
      }
    },
    setCategoryTrendChart(data = []) {
      this.trendChart = echarts.init(this.$refs.categoryTrend, 'customed')
      const option = {
        tooltip: {
          show: true,
          trigger: 'axis',
        },
        grid: {
          top: '4%',
          left: '10%',
          right: '8%',
          bottom: '12%',
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: data.map(el => el.payDate),
          axisTick: { show: false },
        },
        yAxis: {
          type: 'value',
          axisLabel: { color: '#fff' },
          axisTick: {
            show: false,
          },
          splitLine: { lineStyle: { color: '#535355' } },
        },
        series: [
          {
            type: 'line',
            labelLine: {
              show: false,
            },
            name: this.$t('ocean-bi::sale-area::销量'),
            areaStyle: {},
            data: data.map(el => Number(el.sale)),
          },
        ],
      }
      this.trendChart.setOption(option)
    },
    changeZone(params) {
      this.params.countryCode =
        params.name !== 'world' && params.data && params.data.data ? params.data.data.countryCode : ''
      this.params.countryName = params.name === 'world' ? '' : params.name
      this.getAllData()
    },
    screenEvent() {
      this.listenAllScreenKeyUp = e => {
        //   /*判断是否全屏*/
        var isFullscreen =
          document.fullScreenElement || // W3C
          document.msFullscreenElement || // IE
          document.mozFullScreenElement || // 火狐
          document.webkitFullscreenElement || // 谷歌
          false
        this.$store.commit('setScreen', isFullscreen ? true : false)
      }
      addResizeListener(document.body, this.listenAllScreenKeyUp)
    },
  },
  beforeDestroy() {
    clearInterval(this.countryFocusInterval)
    removeResizeListener(this.listenAllScreenKeyUp)
  },
}
</script>

<style lang="scss" scoped>
.screen-container {
  /deep/.el-input__inner {
    background-color: #1f1f21;
    border: 1px solid #2d2d30;
    color: #fff;
  }
  /deep/.el-range-separator {
    color: #fff;
  }
  /deep/.el-range-input {
    color: #fff;
  }
  position: relative;
  background: #2d2d30;
  color: #fff;
  margin: -24px;
  width: calc(100% + 48px) !important;
  padding: 2%;
  min-height: calc(100vh - 96px);
  overflow: auto;

  // font-size: 1vw;
  .search {
    position: relative;
    z-index: 10;
    padding: 12px 16px 0;
    background: #3b3b40;
    border-radius: 6px;
    margin-bottom: 16px;
    /deep/.el-form-item {
      margin-bottom: 12px;
    }
    /deep/.el-form-item__label {
      color: #fff;
    }
  }
  .sale-range-city {
    width: 338px;
    background: #222224;
    border-radius: 12px;
    height: 470px;
    .title {
      background: rgba(59, 59, 64, 0.8);
      border-radius: 10px 10px 0px 0px;
      font-weight: bold;
      color: #ffffff;
      padding: 15px 24px;
    }
    .cityRange {
      padding: 24px;
      .bar-item:first-child {
        margin-top: 0px;
      }
    }
  }
  .category-sale {
    position: relative;
    z-index: 10;
    height: 834px;
    background: #222224;
    border-radius: 12px;
    margin-top: 16px;
    padding: 24px;
    .title {
      font-weight: bold;
      color: #ffffff;
      font-size: 16px;
    }
    .category-overview {
      margin: 20px 0;
      height: 260px;
      overflow: auto;
    }
  }
  .bar-item:first-child {
    margin-top: 0px;
  }
}
.bar-item {
  display: flex;
  align-items: center;
  .bar-name {
    width: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 13px;
    opacity: 0.7;
  }
  .progress {
    flex: 1;
    margin-left: 10px;
    /deep/.el-progress-bar__inner {
      border-radius: 3px;
      text-align: left;
    }
    /deep/.el-progress-bar__outer {
      border-radius: 3px;
      background: #2d2d30;
    }
    /deep/.el-progress-bar__innerText {
      margin: 0 8px;
    }
  }
  margin-top: 20px;
}
.progress {
  /deep/.el-popover {
    background: #3b3b40 !important;
    border: 1px solid #3b3b40 !important;
  }
  /deep/.popper__arrow::after {
    border-right-color: #3b3b40 !important;
    color: #3b3b40 !important;
    left: 0px !important;
  }
  .bar-popover-title {
    font-size: 16px;
    margin-bottom: 20px;
    color: #fff;
    font-weight: bold;
  }
  .bar-popover-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #fff;
  }
  .bar-popover-content + .bar-popover-content {
    margin-top: 16px;
  }
}
.custom-card {
  height: 340px;
  background: #28282a;
  border-radius: 8px;
  .header {
    background: #343437;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 24px;
    border-radius: 10px 10px 0px 0px;
    border-bottom: 1px solid rgba(89, 89, 89, 0.3);
  }
  .category-trend {
    margin: 20px 0px 0px;
    height: 250px;
  }
  .spu-table {
    // padding: 24px 30px;
    /deep/.el-table--border th,
    .el-table--border td {
      background: #343437;
      color: #fff;
    }
    /deep/.el-table__empty-block {
      background: #28282a;
      color: #fff;
    }
    /deep/.el-table th {
      // background: #343437;

      background: #2d2d30;
      color: #fff;
    }
    /deep/.el-table tr {
      background: #28282a;
      color: #fff;
      font-size: 12px;
    }
    /deep/.el-table--enable-row-hover .el-table__body tr:hover > td {
      background: #28282a;
      color: #fff;
    }
    /deep/.el-scrollbar-table .el-scrollbar__wrap {
      background: #28282a;
    }
    /deep/.el-table th.is-leaf,
    .el-table td {
      border-bottom: none;
    }
    /deep/.el-table {
      border: 1px solid #343437;
    }
    /deep/.el-table thead .cell {
      opacity: 0.8;
    }
    /deep/.el-table::before {
      background: #28282a;
    }
    /deep/.el-table td {
      border-bottom: 1px solid #343437;
    }
    /deep/.el-table--enable-row-transition .el-table__body td {
      transition: none;
    }
  }
}
.map {
  top: 0;
  right: 0;
  width: 100%;
  flex: 1;
  position: relative;
  /deep/.map-container {
    width: 100%;
    height: 100%;
    position: relative;
  }
}
.allScreen {
  position: fixed;
  left: 0px;
  top: 0;
  width: 100% !important;
  height: 100% !important;
  z-index: 2000;
  background: #2d2d30;
  box-sizing: border-box;
  margin: 0;
  overflow: auto;
}
</style>
